module.exports = __webpack_public_path__ + "img/chatbot3.e834f759.svg";